module.exports = __webpack_public_path__ + "img/DancingWithTheMountains.14c63b8a.jpg";